<template>
  <!-- 患者検索 -->
  <div id="AppPatientManagement">
    <!-- 上部余白 -->
    <div style="height: 10px;" />
    <!--検索条件 -->
    <div class="box" style="margin-left: 50px; margin-right: 50px;">
      <template :searchConditions="searchConditions">
        <div class="columns">
          <div class="column">
            <label class="searchTitle label">患者情報管理</label>
          </div>
        </div>
        <!--1行目 -->
        <div class="columns">
          <div class="column is-one-third">
            <b-field label="患者コード" labelPosition="on-border">
              <b-input
                v-model="searchConditions.patientCode"
                name="patientCode"
                data-vv-as="患者コード"
                type="text"
                maxlength="8"
              ></b-input>
            </b-field>
          </div>
          <div class="column is-one-third">
            <b-field label="患者名" labelPosition="on-border">
              <b-input
                v-model="searchConditions.patientName"
                name="patientName"
                data-vv-as="患者名"
                type="text"
              ></b-input>
            </b-field>
          </div>
          <div class="column is-one-third">
            <b-field
              label="患者名(カナ)"
              labelPosition="on-border"
              :type="{ 'is-danger': errors.has('patientNameKana') }"
              :message="errors.first('patientNameKana')"
            >
              <b-input
                v-model="searchConditions.patientNameKana"
                name="patientNameKana"
                data-vv-as="患者名(カナ)"
                type="text"
                field="patientNameKana"
                v-validate="'kanaCheck'"
                @typing="kanaInitialization()"
              ></b-input>
            </b-field>
          </div>
        </div>
        <!--2行目 -->
        <div class="columns">
          <div class="column is-one-third">
            <b-field label="営業所コード" labelPosition="on-border">
              <b-input
                v-model="searchConditions.officeCode"
                name="officeCode"
                data-vv-as="営業所コード"
                type="text"
              ></b-input>
            </b-field>
          </div>
          <div class="column is-one-third">
            <b-field label="医療機関コード" labelPosition="on-border">
              <b-input
                v-model="searchConditions.hospitalCode"
                name="hospitalCode"
                data-vv-as="医療機関コード"
                type="text"
                maxlength="8"
              ></b-input>
            </b-field>
          </div>
          <div class="column is-one-third">
            <b-field label="医療機関名" labelPosition="on-border">
              <b-input
                v-model="searchConditions.hospitalName"
                name="hospitalName"
                data-vv-as="医療機関名"
                type="text"
              ></b-input>
            </b-field>
          </div>
        </div>
        <!--3行目 -->
        <div class="columns">
          <div class="column is-one-third">
            <b-field label="品目コード" labelPosition="on-border">
              <b-input
                v-model="searchConditions.productCode"
                name="productCode"
                data-vv-as="品目コード"
                type="text"
              ></b-input>
            </b-field>
          </div>
          <div class="column is-one-third">
            <b-field label="品目名" labelPosition="on-border">
              <b-input
                v-model="searchConditions.productName"
                name="productName"
                data-vv-as="品目名"
                type="text"
              ></b-input>
            </b-field>
          </div>
          <div class="column is-one-third">
            <b-field label="シリアル" labelPosition="on-border">
              <b-input
                v-model="searchConditions.serialNumber"
                name="serialNumber"
                data-vv-as="シリアル"
                type="text"
              ></b-input>
            </b-field>
          </div>
        </div>
        <!--3行目 -->
        <div class="columns">
          <div class="column is-one-third">
            <b-field label="電話番号" labelPosition="on-border">
              <b-input
                v-model="searchConditions.patientPhone"
                name="patientPhone"
                data-vv-as="電話番号"
                type="text|max:20"
              ></b-input>
            </b-field>
          </div>
          <div class="column is-one-third">
            <b-field label="郵便番号" labelPosition="on-border">
              <b-input
                v-model="searchConditions.zipCode"
                name="zipCode"
                data-vv-as="郵便番号"
                type="text"
              ></b-input>
            </b-field>
          </div>
        </div>
        <!-- 検索実行ボタン-->
        <div class="columns" style="text-align:center;">
          <div class="column">
            <b-button
              class="button"
              type="is-primary"
              icon-right="magnify"
              native-type="button"
              @click="search(searchConditions)"
            >検索する</b-button>
          </div>
        </div>
        <div class="columns" style="text-align:center;">
          <div class="column">
            <span
              style="color: red"
              v-if="isSearchConditionKana&&!this.kanaJudg(searchConditions.patientNameKana)"
            >検索条件に誤りがあります。</span>
            <span style="color: red" v-else-if="isSearchConditionNull">検索条件を指定してください。</span>
            <span style="color: red" v-if="isSearchConditionAll">全件検索となる為、検索条件を絞り込んでください。</span>
          </div>
        </div>
      </template>
    </div>
    <!-- 検索結果 -->
    <section>
      <div
        v-if="data.length > 0"
        class="box"
        style="resultArea; margin-left: 50px; margin-right: 50px;"
      >
        <div class="columns">
          <div class="column is-two-thirds" style="text-align: left">
            <b-button
              class="button is-primary has-text-centered"
              icon-left=""
              :disabled="!checkedRows.length"
              native-type="button"
              position="is-right"
              @click="showEmergancyLevelChooser()"
              >緊急連絡レベル設定</b-button
            >
          </div>
          <div class="column is-one-third">
            <b-field horizontal label="患者検索結果" style="float:right; white-space:nowrap;">
              <b-select position="is-right" v-model="perPage">
                <option value="10">10</option>
                <option value="20">20</option>
                <option value="50">50</option>
              </b-select>
            </b-field>
          </div>
        </div>
        <div>
          <b-table
            :data="data"
            :paginated="isPaginated"
            :per-page="perPage"
            :current-page.sync="currentPage"
            :pagination-simple="isPaginationSimple"
            :pagination-position="paginationPosition"
            :pagination-size="paginationSize"
            :default-sort-direction="defaultSortDirection"
            default-sort="staffCode"
            checkable
            :checked-rows.sync="checkedRows"
            checkbox-position="left"
            aria-next-label="Next page"
            aria-previous-label="Previous page"
            aria-page-label="Page"
            aria-current-label="Current page"
            @check-all="checkAll($event)"
          >
            <template slot-scope="props">
              <b-table-column
                field="patientCode"
                label="患者コード"
                sortable
                centered
              >{{ props.row.patientCode }}</b-table-column>
              <b-table-column
                field="patientName"
                label="患者名"
                sortable
                centered
              >{{ props.row.patientName }}</b-table-column>
              <b-table-column field="patientNameKana" label="患者名（カナ）" sortable centered>
                <template v-if="props.row.patientNameKana">{{props.row.patientNameKana}}</template>
              </b-table-column>
              <b-table-column field="officeCode" label="営業所" sortable centered>
                <span
                  v-for="officeCode in getOfficeName(props.row.officeCode)"
                  :value="officeCode"
                  :key="officeCode"
                >
                  {{ officeCode|officeFilter(officeMaster) }}
                  <br />
                </span>
              </b-table-column>
              <b-table-column
                field="patientPhone"
                label="電話番号"
                sortable
                centered
              >{{ props.row.patientPhone }}</b-table-column>
              <b-table-column
                field="staffName"
                label="点検担当者"
                sortable
                centered
                >{{ props.row.staffName }}</b-table-column
              >
              <b-table-column
                field="emergencyLevel"
                label="緊急連絡レベル"
                sortable
                centered
                >{{
                  props.row.emergencyLevel | anpyLevelFilter
                }}</b-table-column
              >
              <b-table-column label=" 編集" centered>
                <b-button
                  class="button is-primary has-text-centered"
                  icon-left="mdi mdi-cog"
                  native-type="button"
                  size="is-small"
                  v-on:click="doPatientEdit(props.row.patientCode)"
                ></b-button>
              </b-table-column>
            </template>
          </b-table>
        </div>
      </div>
    </section>
    <!-- 下部余白 -->
    <div style="height: 10px;" />

    <emergency-level-chooser
      v-model="isShowEmergencyLevelChooser"
      @selected="updateEmergencyLevel($event)"
    />
  </div>
</template>

<script>
import EmergencyLevelChooser from "./common/EmergencyLevelChooser.vue";
import * as patient from "../utils/patient";
export default {
  name: "AppPatientManagement",
  methods: {
    getOfficeName: function(value) {
      return value.split(",");
    },
    search: function(searchConditions) {
      this.checkedRows = [];
      if (
        this.isLength(searchConditions.patientCode) ||
        this.isLength(searchConditions.patientName) ||
        this.isLength(searchConditions.officeCode) ||
        this.isLength(searchConditions.hospitalCode) ||
        this.isLength(searchConditions.hospitalName) ||
        this.isLength(searchConditions.productCode) ||
        this.isLength(searchConditions.productName) ||
        this.isLength(searchConditions.patientPhone) ||
        this.isLength(searchConditions.serialNumber) ||
        this.isLength(searchConditions.zipCode) ||
        this.isLength(searchConditions.patientNameKana) ||
        this.searchConditions.includeDeleted
      ) {
        if (
          this.isLength(this.searchConditions.patientNameKana) &&
          !this.kanaJudg(this.searchConditions.patientNameKana)
        ) {
          this.isSearchConditionKana = true;
        } else {
          console.log("検索条件あり");
          this.isSearchConditionNull = false;

          if (
            !this.isLength(searchConditions.patientCode) &&
            !this.isLength(searchConditions.patientName) &&
            !this.isLength(searchConditions.officeCode) &&
            !this.isLength(searchConditions.hospitalCode) &&
            !this.isLength(searchConditions.hospitalName) &&
            !this.isLength(searchConditions.productCode) &&
            !this.isLength(searchConditions.productName) &&
            !this.isLength(searchConditions.patientPhone) &&
            !this.isLength(searchConditions.serialNumber) &&
            !this.isLength(searchConditions.zipCode) &&
            !this.isLength(searchConditions.patientNameKana) 
          ) {
            if (
              this.isSearchAll(
                [this.searchConditions.includeDeleted ? 1 : 0, 1]
              )
            ) {
              this.isSearchConditionAll = true;
              return;
            }
          }
          this.isSearchConditionAll = false;

          var excuteApi = this.getPatientListPOST;
          var successCallBack = this.getPatientListSuccess;
          var errorCallBack = this.getPatientListError;
          // WebAPI Call
          this.apiCall(excuteApi, successCallBack, errorCallBack);
        }
      } else {
        console.log("検索条件未入力");
        this.isSearchConditionNull = true;
        this.isSearchConditionAll = false;
      }
    },
    doPatientEdit: function(code) {
      this.$router.push({
        name: "AppPatientManagementEditPatient",
        params: {
          code: code,
          searchConditions: this.searchConditions
        }
      });
    },
    getPatientListPOST: function(client) {
      return client.apis.apiPatient.getPatientListPOST({
        body: {
          patientCode: this.searchConditions.patientCode,
          patientName: this.searchConditions.patientName,
          patientNameKana: this.searchConditions.patientNameKana,
          officeCode: this.searchConditions.officeCode,
          hospitalCode: this.searchConditions.hospitalCode,
          hospitalName: this.searchConditions.hospitalName,
          productCode: this.searchConditions.productCode,
          productName: this.searchConditions.productName,
          patientPhone: this.searchConditions.patientPhone,
          serialNumber: this.searchConditions.serialNumber,
          zipCode: this.searchConditions.zipCode,
          includeDeleted: this.searchConditions.includeDeleted,
          nationwideSearchFlag: true,
        }
      });
    },
    getPatientListSuccess: function(result) {
      // WebAPI応答内容を画面に設定
      this.data = result.obj;
    },
    getPatientListError: function (result) {
      this.showErrorMessage(result);
    },
    showEmergancyLevelChooser: function () {
      this.isShowEmergencyLevelChooser = true;
      return;
    },

    updateEmergencyLevel: function (emergencyLevel) {
      // 緊急連絡レベル一括更新
      this.targetEmergencyLevel = emergencyLevel;
      this.apiCall(this.putPatients, this.putPatientsSuccess, this.showErrorMessage);
      return;
    },

    putPatients: function (client) {
      // パラメータ編集
      const patientList = [];
      for (const row of this.checkedRows) {
        const patient = {
          patientCode: row.patientCode,
          emergencyLevel: this.targetEmergencyLevel.code + "",
        };
        patientList.push(patient);
      }

      // 緊急連絡レベル一括更新
      const res = client.apis.apiPatient.putPatientsPUT({
        body: {
          patientList: patientList,
        },
      });

      this.targetEmergencyLevel = null;
      return res;
    },

    putPatientsSuccess: function (result) {
      if (result.obj) {
        this.showSuccess(result);
      }
      this.search(this.searchConditions);
      return;
    },

    checkAll: function(rows) {
      if (rows.length > this.checkedRows.length) {
        this.$nextTick(() => { this.checkedRows = this.data });
      } else {
        this.$nextTick(() => { this.checkedRows = [] });
      }
      return;
    },
  },
  data() {
    var data = [];
    var userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
    var searchConditions = {
      patientCode: "",
      patientName: "",
      patientNameKana: "",
      officeCode: "",
      hospitalCode: "",
      hospitalName: "",
      productCode: "",
      productName: "",
      patientPhone: "",
      serialNumber: "",
      zipCode: "",
      includeDeleted: false,
    };
    var officeMaster = JSON.parse(sessionStorage.getItem("officeMaster"));
    if (this.$route.params["searchConditions"]) {
      searchConditions = this.$route.params["searchConditions"];
    } else {
      if (userInfo.roleId != 1) {
        searchConditions.officeCode = userInfo.officeCode;
      }
    }
    return {
      data,
      checkedRows: [],
      userInfo,
      officeMaster,
      isPaginated: true,
      isPaginationSimple: false,
      paginationPosition: "top",
      paginationSize: "is-small",
      defaultSortDirection: "asc",
      currentPage: 1,
      perPage: 10,
      searchConditions,
      isSearchConditionNull: false,
      isSearchConditionKana: false,
      isSearchConditionAll: false,
      isShowEmergencyLevelChooser: false,
      targetEmergencyLevel: null,
    };
  },
  filters: {
    officeFilter: function(value, officeMaster) {
      var officeElement = officeMaster.find(v => v.officeCode === value);
      if (officeElement) {
        return officeElement.officeName;
      }
      return "";
    },
  },
  components: {
    "emergency-level-chooser": EmergencyLevelChooser,
  },
  mounted: function () {
    this.search(this.searchConditions);
  }
};
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/AppPatientManagement.vue